// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/domain/astrology/tarot.yaml

import type { TarotReferenceCard } from "./types";
import { majorArcanaTarotCards0 } from "./major-0";
import { majorArcanaTarotCards1 } from "./major-1";

export const majorArcanaTarotCards: readonly TarotReferenceCard[] = [
  ...majorArcanaTarotCards0,
  ...majorArcanaTarotCards1,
];
